import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams, Navigate } from 'react-router-dom';
import { academyAPI } from '../../services/api';

/**
 * Registration used to be its own page, which meant clicking "Register" threw
 * away the academy header, its tab bar and the program's sub-tabs — you ended
 * up on a bare screen that had lost all of its context.
 *
 * The wizard now lives in the Programs tab as another program view, so this
 * route only forwards. It stays mounted because the URL is already out in the
 * world, and because a payment provider redirecting back to
 * /…/programs/:id/register?step=4 should still land in the right place.
 */
const ProgramRegistrationPage = () => {
  const { academyId, slug, programId } = useParams();
  const [searchParams] = useSearchParams();
  const [resolvedSlug, setResolvedSlug] = useState(slug || null);
  const [failed, setFailed] = useState(false);

  // The tab lives at /academy/:slug, so a UUID in the path has to be traded
  // for the slug before we can forward.
  useEffect(() => {
    if (resolvedSlug) return;
    let cancelled = false;
    academyAPI.getById(academyId)
      .then(a => { if (!cancelled) setResolvedSlug(a?.slug || academyId); })
      .catch(() => { if (!cancelled) setFailed(true); });
    return () => { cancelled = true; };
  }, [academyId, resolvedSlug]);

  if (failed) return <Navigate to="/academies" replace />;
  if (!resolvedSlug) return null;

  const step = searchParams.get('step');
  const query = new URLSearchParams({
    tab: 'programs',
    program: programId,
    view: 'register',
    ...(step && { step }),
  });

  return <Navigate to={`/academy/${resolvedSlug}?${query}`} replace />;
};

export default ProgramRegistrationPage;
